import { PureComponent } from 'react';
import Hotkeys from 'react-hot-keys';
import { SlideFromRightWrapper } from '../../../../common/SlideFromRightWrapper';
import { Template } from '../../../../../api/getAttachmentTemplatesForDoctor';
import { Image, List } from 'antd';
import VirtualList from 'rc-virtual-list';

interface Props {
    postData?: Template[];
    onClose: () => void;
}

export class AttachmentPatientHistory extends PureComponent<Props> {
    render() {
        const { postData, onClose } = this.props;

        return (
            <Hotkeys keyName="esc">
                <SlideFromRightWrapper closeMe={onClose}>
                    <div className="bg-darwin-neutral-50 flex flex-col h-full space-between">
                        <div className="flex items-center space-x-16 p-16 border-b border-darwin-neutral-100 cursor-pointer">
                            <div
                                onClick={onClose}
                                className="flex items-center justify-center w-16 h-16"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="w-16 h-16 fill-darwin-neutral-1000"
                                >
                                    <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                                </svg>
                            </div>
                            <p className="text-darwin-neutral-1000 heading-2 bold">
                                Attachment History
                            </p>
                        </div>
                        <div className="p-16 flex flex-col flex-1 space-y-16 h-full overflow-auto">
                            <div className="rounded-8 bg-white flex items-start justify-between">
                                <div className="space-y-8 w-full">
                                    {postData && postData?.length > 0 ? (
                                        <List className="hide-scrollbar h-full overflow-auto">
                                            <VirtualList
                                                className="hide-scrollbar overflow-auto"
                                                data={postData}
                                                itemHeight={47}
                                                itemKey="attachment-list"
                                            >
                                                {(item: Template) => (
                                                    <List.Item
                                                        key={item._id}
                                                        className="px-16 cursor-pointer min-h-84 hover:bg-darwin-neutral-50"
                                                    >
                                                        <List.Item.Meta
                                                            title={item?.meta?.display?.title}
                                                            description={
                                                                item?.meta?.display?.description
                                                            }
                                                        />
                                                        <div className="flex items-center space-x-8">
                                                            {item?.meta?.display?.file_type ? (
                                                                item?.meta?.display?.file_type ===
                                                                'IMG' ? (
                                                                    <Image
                                                                        className="border border-darwin-neutral-200"
                                                                        width={100}
                                                                        height={60}
                                                                        preview={{
                                                                            mask: (
                                                                                <span
                                                                                    role="img"
                                                                                    aria-label="eye"
                                                                                    className="anticon anticon-eye"
                                                                                >
                                                                                    <svg
                                                                                        viewBox="64 64 896 896"
                                                                                        focusable="false"
                                                                                        data-icon="eye"
                                                                                        width="1em"
                                                                                        height="1em"
                                                                                        fill="currentColor"
                                                                                        aria-hidden="true"
                                                                                    >
                                                                                        <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            ),
                                                                        }}
                                                                        src={
                                                                            item?.meta?.display
                                                                                ?.link
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <a
                                                                        className="space-x-8 mx-4 hover:opacity-70 flex px-12 py-5 secondary-btn btn--small cursor-pointer items-center"
                                                                        href={
                                                                            item?.meta?.display
                                                                                ?.link
                                                                        }
                                                                        target="_blank"
                                                                    >
                                                                        <i>open file</i>
                                                                        <span>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                viewBox="0 0 512 512"
                                                                                className="w-14 h-16 fill-actionPrimary-hover"
                                                                            >
                                                                                <path d="M133.9 232L65.8 95.9 383.4 232H133.9zm0 48H383.4L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z" />
                                                                            </svg>
                                                                        </span>
                                                                    </a>
                                                                )
                                                            ) : (
                                                                <span className="px-4 text-neutral-4 font-700 flex items-center space-x-8">
                                                                    No file Attached
                                                                </span>
                                                            )}
                                                        </div>
                                                    </List.Item>
                                                )}
                                            </VirtualList>
                                        </List>
                                    ) : (
                                        <p className="body-1 bold text-darwin-neutral-1000 p-16">
                                            No Attachment History Found!
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </SlideFromRightWrapper>
            </Hotkeys>
        );
    }
}

export default AttachmentPatientHistory;
